<template>
    <div class="container-fluid">
        <div class="row" style="margin-top:20px;">
            <div class="col-lg-12 form-inline text-right" style="margin-bottom: 20px">
                <button class="btn btn-default" @click.prevent="getTemplates"><i class="fas fa-sync-alt"></i></button>
                <a href="/microsites" class="btn btn-primary">Microsites</a>
                <button class="btn btn-success" @click.prevent="newTemplate">New Template</button>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="table-responsive">
                    <table class="table table-striped microsite-templates-table">
                        <thead>
                        <tr class="side-borders th_font">
                            <th>Id</th>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Template Name</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-show="showLoading">
                            <td colspan="5" class="text-center">
                                <i class="fa fa-spinner fa-spin fa-3x grey"></i><br/><br/>
                                Loading Microsite Templates
                            </td>
                        </tr>
                        <tr v-show="showNoResultsFound">
                            <td colspan="5" class="text-center">
                                No results found
                            </td>
                        </tr>
                        <tr v-for="template in templates" v-if="!showLoading">
                            <td>{{ template.id }}</td>
                            <td>{{ template.name }}</td>
                            <td>{{ template.description }}</td>
                            <td>{{ template.template_name }}</td>
                            <td>
                                <button @click.prevent="editTemplate(template)" class="btn btn-sm btn-info">
                                    <i class="fas fa-cog"></i>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <modal @close="newModal = false" modal-width="75%" v-show="newModal">
            <template slot="header"><h3 style="margin: 0">New Template</h3></template>
            <template slot="body">
                <div class="form-group">
                    <label for="new_name">Name</label>
                    <input type="text" class="form-control" id="new_name" placeholder="Name" v-model="newTemplateData.name">
                </div>
                <div class="form-group">
                    <label for="new_description">Description</label>
                    <input type="text" class="form-control" id="new_description" placeholder="Description"
                           v-model="newTemplateData.description">
                </div>
                <div class="form-group">
                    <label for="new_template_name">Template Name</label>
                    <input type="text" class="form-control" id="new_template_name" placeholder="Template Name"
                           v-model="newTemplateData.template_name">
                </div>
            </template>
            <template slot="footer">
                <button class="btn btn-success" @click.prevent="saveNew()">Create</button>
            </template>
        </modal>

        <modal @close="editModal = false" modal-width="75%" v-show="editModal">
            <template slot="header"><h3 style="margin: 0">Edit Template</h3></template>
            <template slot="body">
                <div class="form-group">
                    <label for="edit_name">Name</label>
                    <input type="text" class="form-control" id="edit_name" placeholder="Name" v-model="editTemplateData.name">
                </div>
                <div class="form-group">
                    <label for="edit_description">Description</label>
                    <input type="text" class="form-control" id="edit_description" placeholder="Description"
                           v-model="editTemplateData.description">
                </div>
                <div class="form-group">
                    <label for="edit_template_name">Template Name</label>
                    <input type="text" class="form-control" id="edit_template_name" placeholder="Template Name"
                           v-model="editTemplateData.template_name">
                </div>
            </template>
            <template slot="footer">
                <button class="btn btn-success" @click.prevent="saveEdit()">Save</button>
            </template>
        </modal>
    </div>
</template>

<script>
export default {
    name: "microsite-templates",
    props: [],
    data() {
        return {
            is_loading: false,
            templates: [],
            newTemplateData: {
                name: '',
                description: '',
                template_name: ''
            },
            editTemplateData: {
                id: null,
                name: null,
                description: null,
                template_name: null
            },
            newModal: false,
            editModal: false,
        };
    },
    mounted() {
        this.getTemplates();
    },
    computed: {
        showLoading() {
            return this.is_loading;
        },
        showNoResultsFound() {
            return this.is_loading === false && this.hasTemplates === false;
        },
        hasTemplates() {
            return this.templates.length > 0;
        },
    },
    methods: {
        getTemplates() {
            this.is_loading = true;
            axios.get('/microsites/templates/data')
                .then(response => {
                    this.templates = response.data;
                    this.is_loading = false;
                });
        },
        newTemplate() {
            this.newTemplateData.name = '';
            this.newTemplateData.description = '';
            this.newTemplateData.template_name = '';

            this.newModal = true;
        },
        saveNew() {
            axios.post('/microsites/templates/', this.newTemplateData)
                .then(response => {
                    this.getTemplates();
                    this.newModal = false;
                })
        },
        editTemplate(template) {
            this.editTemplateData.id = template.id;
            this.editTemplateData.name = template.name;
            this.editTemplateData.description = template.description;
            this.editTemplateData.template_name = template.template_name;

            this.editModal = true;
        },
        saveEdit() {
            axios.post('/microsites/templates/' + this.editTemplateData.id, this.editTemplateData)
                .then(response => {
                    this.getTemplates();
                    this.editModal = false;
                })
        }
    }
}
</script>

<style scoped>
.microsite-templates-table {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
}
</style>